import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setGridConfig } from '../../../actions/shared/productGrid';
import queryUtil from '../../../modules/ajio-util/query.js';
import commify from '../../../modules/ajio-util/commify.js';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreens from '../../../refresh/constants/luxeScreenType';

class TopBar extends React.Component {
  render() {
    const {
      totalResults,
      freeTextSearch,
      pushToHistory,
      location,
      facets = [],
      autoCorrect,
      originalSearchTerm,
      luxe,
      storeName
    } = this.props;
    const searchStore = ['ajio', 'luxe', 'ajiogram'].includes(storeName) ? storeName : 'ajio';
    const query = queryUtil.parseSearch(location.search);
    const { gridColumns = '2' } = query;
    var searchedTerm = '';
    var isAutoCorrect = false;
    if (autoCorrect == true) {
      isAutoCorrect = true;
      searchedTerm = originalSearchTerm.split(':')[0];
      if (luxe && originalSearchTerm && freeTextSearch) {
        const {
          search: { screenName = '', screenType = '' }
        } = luxeScreens;
        gtmEventPush({
          event: 'search_autocorrection_click',
          event_category: 'search_interactions',
          event_action: 'auto-correction',
          event_label: `${originalSearchTerm}-${freeTextSearch}`,
          page_name: `Search Screen/${searchStore}`,
          page_type: screenType,
          store_type: storeName
        });
      }
    }

    return (
      <div>
        {isAutoCorrect ? (
          <div className="autocorrect-suggestion">
            <div className="fnl-plpsearch-firstLine">
              Sorry! No results found for <span>{searchedTerm}</span>. Showing results for{' '}
              <span>{freeTextSearch}</span>.
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { request, productsAdditionalInfo = {} } = state;
  const { totalResults = 0 } = request;
  const { freeTextSearch = '', autoCorrect, originalSearchTerm } = productsAdditionalInfo;
  const { facets = [] } = state;
  return {
    totalResults,
    freeTextSearch,
    facets,
    autoCorrect,
    originalSearchTerm,
    storeName: getCurrentStore(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setGridConfig: props => {
      dispatch(setGridConfig(props));
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopBar));

/* <span
  className={`one-column-grid ${gridColumns == "1"
    ? "selected"
    : ""}`}
  onClick={() => {
    pushToHistory({
      gridColumns: 1
    });
    this.props.setGridConfig({ gridColumns: 1 });
  }}
/>
<span
  className={`two-column-grid ${gridColumns == "2"
    ? "selected"
    : ""}`}
  onClick={() => {
    pushToHistory({
      gridColumns: 2
    });
    this.props.setGridConfig({ gridColumns: 2 });
  }}
/> */
